import colors, { Color, ColorKeys } from '@/styles/colors';
import { luminance } from '@/utils/utils';
import beTwMerge from '@/utils/beTwMerge';

interface ContentBlockSectionProps {
  backgroundColor: ColorKeys;
  header?: string;
  children: React.ReactNode; // Change the prop type to React.ReactNode
  classNames?: string;
}

export default function ContentBlockSection({
  backgroundColor = 'white',
  header,
  classNames,
  children,
}: ContentBlockSectionProps) {
  const background: Color = colors[backgroundColor];
  const textColorClass = luminance(background.raw) <= 110 ? 'tw-text-color-white' : '';

  return (
    <div
      className={beTwMerge(
        `tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-px-[0px] tw-bg-${background.tailwind} tw-gap-8 lg:tw-gap-16`,
        classNames
      )}
    >
      {header && (
        <div className="tw-flex tw-flex-col tw-px-[16px] lg:tw-px-[20px] tw-mt-14 lg:tw-mt-20">
          <h2 className={`tw-mb-0 tw-text-center tw-z-10 h2b ${textColorClass}`}>{header}</h2>
        </div>
      )}
      <div
        className={beTwMerge(
          'tw-w-full',
          '[&_section]:tw-py-0 [&_section]:lg:tw-py-0 [&_section]:tw-my-8 [&_section]:lg:tw-my-16',
          header && '[&_section:first-of-type]:tw-mt-0 [&_section:first-of-type]:lg:tw-mt-0'
        )}
      >
        {children}
      </div>
    </div>
  );
}
